import { render } from "./Create.vue?vue&type=template&id=7927d678&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=7927d678&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7927d678"

export default script